/**
 * What the docs tell an AI agent reading them (design §0.9): the site's name and where the machine
 * copies are. The site prints the pointer as each page's invisible preface.
 *
 * The behaviour rules are NOT here: their one home is the API (`GET /v1/meta` `agents`, the same
 * rules every task's `llms.txt` prints — K109). The build reads them and prints them at the top of
 * `llms.txt` and, where a page places `::agent-rules`, into that page (Agent-readable surfaces).
 */

export const SITE_NAME = "Refabric developer docs";

/** The one-line pointer every HTML page carries for agents (design §0.2 "gizli llms.txt notu"). */
export const agentPreface = (llmsUrl: string, markdownUrl: string): string => `For AI agents: this page is also available as Markdown at ${markdownUrl}, and the index of every page is ${llmsUrl}.`;
